import n from "google-libphonenumber";
function i(r) {
  const e = n.PhoneNumberUtil.getInstance();
  if (typeof r != "string")
    return !1;
  let t;
  try {
    t = e.parse(r);
  } catch {
    return !1;
  }
  return e.format(
    t,
    n.PhoneNumberFormat.E164
  ) !== r ? !1 : e.isValidNumber(t);
}
function s(r) {
  if (!i(r))
    throw new Error("Not a valid E.164 phone number string");
  return r;
}
function f(r) {
  const e = n.PhoneNumberUtil.getInstance();
  if (typeof r != "string")
    return;
  let t;
  try {
    t = e.parse(r);
  } catch {
    return;
  }
  if (!e.isValidNumber(t))
    return;
  const o = e.format(
    t,
    n.PhoneNumberFormat.E164
  );
  if (i(o))
    return o;
}
export {
  i as isE164PhoneNumberString,
  s as toE164PhoneNumberStringOrThrow,
  f as toE164PhoneNumberStringOrUndefined
};
